import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { FaPlus } from "react-icons/fa";
import { FaTrash } from "react-icons/fa";


export default function AddPackage() {

  const [name, setName] = useState();
  const [type, setType] = useState();
  const [grade, setGrade] = useState([]);
  const [total_request, setTotalRequest] = useState();
  const [amount, setAmount] = useState();
  const [selectType, setSelectType] = useState(1);
  const [description, setDescription] = useState([{ value: "" }]);
  const adminToken = localStorage.getItem("authAdminToken");
  const navigate = useNavigate();


  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!name) {
      toast.info("Name field is required.");
      return;
    }
    if (grade.length == 0) {
      toast.info("Grade field is required.");
      return;
    }
    if (selectType == 1 && !total_request) {
      toast.info("Total Request field is required.");
      return;
    }
    if (!amount) {
      toast.info("Amount field is required.");
      return;
    }
    if (description.length == 0) {
      toast.info("Description field is required.");
      return;
    }

    const package_data = {
      name: name,
      grade: grade,
      total_request: total_request,
      amount: amount,
      type: type,
      description: description.map((elem) => elem.value),
      request_type: selectType
    };
    const postData = structuredClone(package_data);

    postData.description = postData.description.filter((elem) => elem != "");
    postData.description = JSON.stringify(postData.description);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/createSubscriptionPackage`, {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          "Authorization": `Bearer ${adminToken}`
        },
        body: JSON.stringify(postData),
      });
      const data = await response.json();

      if (data.status === true) {
        toast.success("Subscription Package add successfully!");
        setDescription([{ value: "" }]);
        setAmount("");
        setTotalRequest("");
        setGrade("");
        setType("");
        setName("");
      } else {
        toast.error("Failed to add Subscription Package. Please try again.");
        navigate('/admin/addpackage');
      }

    } catch (error) {
      toast.error("Something went wrong! Please try again later.");
    }

  };

  // const options = [
  //   { value: '6-8', label: '6-8' },
  //   { value: '9-10', label: '9-10' },
  //   { value: '11-12', label: '11-12' }
  // ]
  const animatedComponents = makeAnimated();

  return (
    <>
      {/* Toast container */}
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />

      <div className="container-xxl flex-grow-1 container-p-y" style={{ margin: "4em 42em" }}>
        <div className="app-ecommerce">
          <div className="row">
            <div className="col-12 col-lg-8">
              <div className="card mb-6">
                <div className="card-header">
                  <h5 className="card-tile mb-0">Add Subscription Package</h5>
                </div>
                <div className="card-body">

                  <form onSubmit={(event) => { handleSubmit(event) }}>
                    <div className="row gx-5 mb-5">
                      <div className="col">
                        <div className="form-floating form-floating-outline">
                          <input type="text" className="form-control" value={name} onChange={(event) => { setName(event.target.value) }} placeholder="Enter Name" />
                          <label htmlFor="name">Name</label>
                        </div>
                      </div>
                    </div>
                    <select class="form-select mb-4" onChange={(event) => { setSelectType(event.target.value) }} aria-label="Default select example">
                      <option value="1">Limited</option>
                      <option value="2">Unlimited</option>
                    </select>
                    {selectType == 1 &&
                      <div className="row gx-5 mb-5 mt-5">
                        <div className="col">
                          <div className="form-floating form-floating-outline">
                            <input type="text" className="form-control" value={total_request} onChange={(event) => { setTotalRequest(event.target.value) }} placeholder="Enter Total Request" />
                            <label htmlFor="totalrequest">Total Request</label>
                          </div>
                        </div>
                      </div>
                    }

                    <div className="row gx-5 mb-5">
                      <div className="col">
                        <div className="form-floating form-floating-outline">
                          <input type="text" className="form-control" value={amount} onChange={(event) => { setAmount(event.target.value) }} placeholder="Enter Amount" />
                          <label htmlFor="amount">Amount</label>
                        </div>
                      </div>
                    </div>


                    <div className=" gx-5 mb-5">
                      {description.map((desc, index) => {
                        return <div className="col mb-2 d-flex">
                          <div className="form-floating form-floating-outline w-100 me-3">
                            <input type="text" value={desc.value} onChange={(event) => { const data = structuredClone(description); data[index].value = event.target.value; setDescription(data) }} className="form-control" placeholder="Enter Description" />
                            <label htmlFor="description">Description</label>
                          </div>
                          {index > 0 ? <FaTrash color='red' onClick={() => { setDescription(description.filter((elem) => elem != desc)) }} size={20} style={{ cursor: "pointer" }} /> : null}
                        </div>
                      })}
                      <button type='button' className='mt-3 btn btn-primary w-25' onClick={() => { setDescription([...description, { value: "" }]) }} >
                        <FaPlus />
                      </button>
                    </div>

                    <div className="mb-5 col ecommerce-select2-dropdown d-flex justify-content-between align-items-center mt-4 w-100">
                      <div className="form-floating form-floating-outline w-100 me-4">
                        <select className="form-select form-select-sm" data-placeholder="Select Category" value={type} onChange={(event) => { setType(event.target.value) }}>
                          <option value="">Select Type</option>
                          <option value="1">Monthly</option>
                          <option value="2">Yearly</option>
                        </select>
                        <label htmlFor="type">Type</label>
                      </div>
                    </div>

                    <div className="mb-5 col ecommerce-select2-dropdown d-flex justify-content-between align-items-center mt-4 w-100">
                      <div className="form-floating form-floating-outline w-100 me-4">
                        <select className="form-select form-select-sm" data-placeholder="Select Category" value={grade} onChange={(event) => { setGrade(event.target.value) }}>
                          <option value="">Select Level</option>
                          <option value="6-8">6-8</option>
                          <option value="9-10">9-10</option>
                          <option value="11-12">11-12</option>
                        </select>
                        <label htmlFor="level">Level</label>
                      </div>
                    </div>

                    {/* <Select
                      closeMenuOnSelect={false}
                      components={animatedComponents}
                      defaultValue={[options[4], options[5]]}
                      isMulti
                      options={options}
                      onChange={(value) => { if (value) { setGrade(value.map((elem) => elem.value)) } }}
                    /> */}

                    <div className="col-md-3 d-flex gap-4 mx-4 mt-4">
                      <button type="submit" className="btn btn-primary">Add</button>
                    </div>

                  </form>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  )
}
